import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-749c8f8e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "cms-page-title"
};
const _hoisted_4 = {
  class: "channel"
};
const _hoisted_5 = {
  class: "cms-module-title"
};
const _hoisted_6 = {
  class: "channel-content",
  style: {
    "width": "100%",
    "height": "351px"
  }
};
const _hoisted_7 = {
  class: "video"
};
const _hoisted_8 = {
  class: "video-table"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "basicInfo"
};
const _hoisted_11 = {
  class: "cms-module-title"
};
const _hoisted_12 = {
  class: "image"
};
const _hoisted_13 = {
  class: "cms-module-title"
};
const _hoisted_14 = {
  class: "imgae_content"
};
const _hoisted_15 = {
  class: "bigIcon"
};
const _hoisted_16 = {
  class: "bg_upload_tips"
};
const _hoisted_17 = {
  class: "smIcon"
};
const _hoisted_18 = {
  class: "sm_upload_tips"
};
const _hoisted_19 = {
  class: "relation"
};
const _hoisted_20 = {
  class: "cms-module-title"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode( /*#__PURE__*/_toDisplayString('/'));

const _hoisted_22 = {
  class: "result"
};
const _hoisted_23 = {
  class: "blod"
};
const _hoisted_24 = {
  key: 0
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1,
  class: "card_footer"
};
const _hoisted_27 = {
  class: "button-area"
};
const _hoisted_28 = {
  class: "result"
};
const _hoisted_29 = {
  class: "blod"
};
const _hoisted_30 = {
  key: 0
};
const _hoisted_31 = {
  class: "card_footer"
};
const _hoisted_32 = {
  class: "button-area"
};
const _hoisted_33 = {
  class: "dialog-footer"
};
import { reactive, ref, watch, onBeforeUnmount } from 'vue';
import { ElMessage } from 'element-plus';
import { useRoute, useRouter } from 'vue-router';
import reviewSuccessModal from './reviewSuccessModal.vue';
import reviewFailModal from './reviewFailModal.vue';
import { useCommon } from '@/store/useCommon';
import { liveStore } from '@/store/liveStore';
import { storeToRefs } from 'pinia';
import { getLanguageListApi, getEnListApi, getChannelDetailApi, getcountryListApi, getSysDictListApi, getCpspCategoriesApi, editCheckStateApi, editReleaseStateApi, editPhysicalStateApi } from '@/api/live';
import { activeOrFrezz } from '@/assets/config/dicts';
import XEUties from 'xe-utils';
import { useI18n } from 'vue-i18n';
import XgPlayer from '@/components/Xgplayer';
import { ElNotification } from 'element-plus';
import { messageBox } from '@/utils/validate';
export default /*#__PURE__*/_defineComponent({
  __name: 'checkChannel',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'check'
    },
    // detailInfo.state : 频道状态;0未审核,1通过,2未通过,3终端审核,4退回审核
    detailInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['update:modelValue', 'update-list', 'jumpToEdit'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const isVnoAccount = useCommon().userData.roles.some(item => /VNO/ig.test(item)) || useCommon().userData.roles.includes('CUSTOMER_SN'); //区分是否为vno运营商账号

    const {
      t
    } = useI18n();
    const cpspId = useCommon().userData.cid[0];
    const picture = ref([]);
    const router = useRouter();
    const srcList = ref({
      bigIcon: [],
      smIcon: []
    });
    const enList = ref([]);
    const route = useRoute();
    const languageList = ref([]);
    const sysDictList = ref([]);
    const countryList = ref([]);
    const channelData = ref([]);
    const broadcastTypeObj = ref([]);
    const transferProtocolObj = ref([]); // 分发策略选项统一走 liveStore（带缓存，多个组件共享同一份数据，只请求一次）

    const store = liveStore();
    const {
      distributionStrategyOptions
    } = storeToRefs(store);
    const loading = ref(false);
    const treeData = ref(null);
    const treeDataRefresh = ref(false); //分类接口是否已请求完毕的标志

    const relationData = ref([]);
    const reCheck = ref(false); //是否重新审核

    const videoUrl = ref('');
    const xgPlayerRef = ref();
    const videoTableRefList = ref([]);
    const releaseStatus = ref(null); // 上下线状态，0-未上线，1-已上线，2-已下线

    const setRef = el => {
      if (el) {
        videoTableRefList.value.push(el);
      }
    };

    const terminalDialogVisible = ref(false);
    const lookBackObj = ref([]);
    const bindingCategoryData = ref([]); //http://221.4.223.105:11184/TV002@720/index.m3u8

    const url = "http://221.4.223.105:11182/TV003/index.mpd";
    const recheckBtnVisible = computed(() => {
      if (props.detailInfo.state == 1 && releaseStatus.value == 1) {
        // 已审核且已上线的频道不允许重新审核
        return false;
      } else {
        return true;
      }
    });
    watch(() => props.modelValue, async val => {
      if (val) {
        loading.value = true;
        await getCpspCategories();
        getLanguageList();
        getcountryList();
        getEnList();
        getSysDictList('code_protocol');
        getSysDictList('broadcast_type');
        getSysDictList('lookBackSetting');
        getSysDictList('transfer_protocol');
        store.getDistributionStrategyOptions();
        getChannelDetail(props.detailInfo.id);
      } else {
        reCheck.value = false;
        relationData.value = [];
        treeData.value = [];
        channelData.value = [];
      }
    }, {
      immediate: true,
      deep: true
    });

    const getChannelDetail = async id => {
      const {
        code,
        data
      } = await getChannelDetailApi(id);

      if (code === '0') {
        // 时移+min单位
        data.timeShiftNew = data.timeShiftNew ? data.timeShiftNew + ' min' : 0 + ' min';
        actionForm.formData = data;
        releaseStatus.value = data.releaseStatus;
        actionForm.formData.categoryProperty = data.categoryProperty.split(',');
        actionForm.formData.lookBackSetting = findLabel(lookBackObj.value, data.lookBackSetting);
        data.physicalChannels.forEach(item => {
          // 物理频道激活状态为null时默认未激活,防止为null时，弹框异常的问题
          item.state = item.state == null ? 1 : item.state;
        });
        channelData.value = data.physicalChannels;
        picture.value = data.pictures;
        data.pictures.forEach(item => {
          if (item.size === 0) {
            srcList.value.bigIcon = [item.fileURL];
          } else {
            srcList.value.smIcon = [item.fileURL];
          }
        });
        actionForm.formData = data;
        loading.value = false;
        data.categoryPrograms && data.categoryPrograms.forEach(selectItem => {
          // 请求详情要在有treeData之后，即getCpspCategories请求完成后
          let searchTree = XEUties.searchTree(treeData.value, item => item.value == selectItem.categoryId); // 从treeData找到匹配数据再赋值，防止categoryPrograms[0].categoryId与返回的分类id没有匹配

          searchTree.length > 0 && relationData.value.push(searchTree[0]);
          let targetItem = XEUties.findTree(treeData.value, item => item.value == selectItem.categoryId).item;
          selectItem.parentLabel = searchTree.length > 0 ? searchTree[0].label : '/';
          selectItem.subBrandName = searchTree[0].children ? searchTree[0].children[0].label : '/';
          selectItem.label = searchTree && targetItem ? targetItem.label : '/';
        });
        bindingCategoryData.value = data.categoryPrograms;
        console.log('rela', relationData.value);
      } else {
        loading.value = false;
      }
    };

    const getCpspCategories = async (keyword = '', codeProtocol = '') => {
      // 运营商账号用运营商的id,
      // 由频道审核/管理进入当前页面则用上一步选择的cid, 由内容列表进入该页面则用产品运营页设置的productOperationsCid
      let cid = isVnoAccount ? useCommon().userData.cid[0] : sessionStorage.getItem('currentCid') ? sessionStorage.getItem('currentCid') : sessionStorage.getItem('productOperationsCid');
      let params = {
        cid,
        filterRelationAgent: true //过滤关联的子品牌

      };
      treeDataRefresh.value = false;

      if (keyword !== '') {
        params.keyword = keyword;
      }

      if (codeProtocol !== '') {
        params.codeProtocol = Number(codeProtocol);
      }

      const {
        code,
        data
      } = await getCpspCategoriesApi(params);

      if (code == '0') {
        data.forEach(item => item.value = item.id);
        treeData.value = data;
        treeDataRefresh.value = true;
      }
    };

    const getEnList = async () => {
      // 运营商账号用运营商的id,
      // 由频道审核/管理进入当前页面则用上一步选择的cid, 由内容列表进入该页面则用产品运营页设置的productOperationsCid
      let cid = isVnoAccount ? useCommon().userData.cid[0] : sessionStorage.getItem('currentCid') ? sessionStorage.getItem('currentCid') : sessionStorage.getItem('productOperationsCid');
      const {
        code,
        data
      } = await getEnListApi(cid);

      if (code == 0) {
        enList.value = data;
      }
    };

    const getLanguageList = async () => {
      const {
        code,
        data
      } = await getLanguageListApi();

      if (code == 0) {
        languageList.value = data;
      }
    };

    const getcountryList = async () => {
      const {
        code,
        data
      } = await getcountryListApi();

      if (code == 0) {
        countryList.value = data;
      }
    };

    const getSysDictList = async type => {
      const {
        code,
        data
      } = await getSysDictListApi(type);

      if (code == '0') {
        switch (type) {
          case 'code_protocol':
            sysDictList.value = data;
            break;

          case 'broadcast_type':
            broadcastTypeObj.value = data;
            break;

          case 'transfer_protocol':
            transferProtocolObj.value = data;
            break;

          case 'lookBackSetting':
            lookBackObj.value = data;
            break;
        }
      }
    };

    const editCheckState = async params => {
      const {
        code,
        data
      } = await editCheckStateApi(params);
    };

    const editReleaseState = async (channelIds, state) => {
      const {
        code,
        data
      } = await editReleaseStateApi({
        channelIds,
        state
      });
    };

    const findCategoryLabel = (data, level) => {
      // if(data.value===undefined)return false
      let result = '';

      switch (level) {
        case 2:
          result = data.children[0].label ? data.children[0].label : '/';
          break;

        case 3:
          result = data.children[0].children.length === 0 ? '/' : data.children[0].children[0].label;
          break;

        case 4:
          result = data.children[0].children.length === 0 || data.children[0].children[0].children.length === 0 ? '/' : data.children[0].children[0].children[0].label;
          break;
      }

      return result;
    }; // 返回按钮的回调


    const back = () => {
      // 销毁视频组件
      videoUrl.value = '';
      xgPlayerRef.value && xgPlayerRef.value.destroyVideo();
      emit('update:modelValue', false); //emit('update-list')
    }; // 播放按钮的回调


    const play = (i, row) => {
      if (row.transferProtocol === 2) return ElMessage({
        type: 'warning',
        message: t('暂不支持播放该类型视频')
      });

      if (row.transferProtocol === 3) {
        // 获取a链接ref改变href调起vlc播放器播放
        let buttonRef = videoTableRefList.value[i]; // vlc注册表中对应的指令

        buttonRef.href = 'vlc://';
        ElNotification({
          message: t(`请使用vlc播放器播放该视频`)
        }); // 销毁之前已播放的组件，还原传入组件数据

        videoUrl.value = '';
        return xgPlayerRef.value && xgPlayerRef.value.destroyVideo();
      }

      videoUrl.value = row.channelURL;
    };

    const formData = reactive({
      picture: {}
    });
    const actionForm = reactive({
      visible: false,
      // 预览图片路径
      imgUrl: '',
      formList: [[{
        label: '频道名称',
        prop: 'name',
        widgetType: 'text',
        required: true,
        disabled: true
      }, {
        label: '节目识别号（原台标）',
        prop: 'callSign',
        widgetType: 'text',
        required: true,
        disabled: true
      }], [{
        label: '卫星转IPTV参数',
        prop: 'satelliteToIPTV',
        widgetType: 'text',
        required: true,
        disabled: true
      }, {
        label: 'EPG参数',
        prop: 'satellite',
        widgetType: 'text',
        required: true,
        disabled: true
      }], [{
        label: '国家',
        prop: 'country',
        widgetType: 'text',
        list: countryList,
        required: true,
        disabled: true
      }, {
        label: '语言',
        prop: 'language',
        widgetType: 'text',
        list: languageList,
        required: true,
        disabled: true
      }], [{
        label: '成人内容',
        prop: 'playLevel',
        widgetType: 'select',
        required: true,
        disabled: true,
        formatter: val => {
          return val == 0 ? t('否') : t('是');
        }
      }, {
        label: '分类属性',
        prop: 'categoryProperty',
        widgetType: 'text',
        list: enList,
        valueKey: 'label',
        multiple: true,
        disabled: true,
        rules: {
          required: true,
          message: 'please select category!',
          trigger: 'blur'
        }
      }], [{
        label: '音轨设置',
        prop: 'audioList',
        widgetType: 'text',
        disabled: true
      }, {
        label: '显示编号',
        prop: 'showNo',
        widgetType: 'text',
        required: true,
        disabled: true
      }], [{
        label: '详情描述',
        prop: 'description',
        widgetType: 'text',
        disabled: true
      }, {
        label: '字幕设置',
        prop: 'subtitle',
        widgetType: 'text',
        disabled: true
      }], [{
        label: '公共频道序号',
        prop: 'publicChannelSort',
        widgetType: 'text',
        disabled: true
      }, {
        label: '回看设置',
        prop: 'lookBackSetting',
        widgetType: 'text'
      }], [{
        label: '时移',
        prop: 'timeShiftNew',
        widgetType: 'text',
        disabled: true
      }, {
        label: '付费节目',
        prop: 'isPremium',
        widgetType: 'text',
        disabled: true,
        formatter: val => {
          return val == 0 ? t('否') : val == 1 ? 'VIP1' : 'VIP2';
        }
      }], [{
        label: '备注',
        prop: 'remark',
        widgetType: 'text',
        colspan: 3,
        disabled: true
      }]],
      formData,
      dialogConfig: {
        title: '新增'
      },
      fileOnChange: file => {
        // 预览图片
        let reader = new FileReader(); //转base64

        reader.onload = function (e) {
          //将图片路径赋值给src
          actionForm.imgUrl = e.target.result;
        };

        reader.readAsDataURL(file.raw);
      },
      confirm: () => {}
    }); // 打开审核通过的弹框

    const reviewSuccess = () => {
      reviewSuccessObj.dialogVisible = true;
    }; // 取消


    const reviewSuccessCancel = () => {
      reviewSuccessObj.dialogVisible = false;
    }; // 确认审核通过


    const reviewSuccessSuc = async isOnline => {
      let apiArr = [];
      loading.value = true;
      reviewSuccessObj.dialogVisible = false;
      await editCheckStateApi({
        channelIds: props.detailInfo.id,
        state: 1
      }).then(res => {
        ElMessage({
          type: 'success',
          message: t('审核通过')
        });
      }).catch(err => {
        console.log('err375', err);
      });

      if (isOnline) {
        await editReleaseStateApi({
          channelIds: props.detailInfo.id,
          state: 1
        }).then(res => {
          ElMessage({
            type: 'success',
            message: t('上线成功')
          });
        }).catch(err => {
          console.log('err380', err);
        });
      }

      loading.value = false;
      emit('update:modelValue', false);
      emit('update-list'); // 销毁视频组件

      videoUrl.value = '';
      xgPlayerRef.value && xgPlayerRef.value.destroyVideo();
    };

    const reviewSuccessObj = reactive({
      dialogVisible: false,
      title: '审核确认页',
      width: '20%',
      successBtnText: '确定',
      closeBtnText: '取消',
      isFooter: true
    }); // 审核不通过

    const reviewFail = () => {
      reviewFailObj.dialogVisible = true;
    }; // 取消


    const reviewFailCancel = () => {
      reviewFailObj.dialogVisible = false;
    }; // 确认


    const reviewFailSuc = reason => {
      reviewFailObj.dialogVisible = false;
      loading.value = true;
      let params = {
        channelIds: props.detailInfo.id,
        state: 2,
        checkFailedReason: reason
      };
      Promise.all([editCheckState(params)]).then(res => {
        loading.value = false;
        emit('update:modelValue', false);
        emit('update-list');
      }).catch(err => {
        loading.value = false;
      }); // 销毁视频组件

      videoUrl.value = '';
      xgPlayerRef.value && xgPlayerRef.value.destroyVideo();
    };

    const reviewFailObj = reactive({
      dialogVisible: false,
      title: '审核不通过原因',
      width: '30%',
      successBtnText: '确定',
      closeBtnText: '取消',
      isFooter: true
    }); // 编辑频道按钮的回调

    const onEditChannel = () => {
      videoUrl.value = '';
      xgPlayerRef.value && xgPlayerRef.value.destroyVideo();
      emit('update:modelValue', false);
      emit('jumpToEdit', props.detailInfo.id);
    }; // 查label


    const findLabel = (dataList, value) => {
      let label = '';
      dataList.forEach(item => {
        if (item.value == value) {
          label = item.label;
        }
      });
      return label === '' ? label : t(label);
    }; // 查分发策略 label：store 里的 label 已是最终文案（固定项为翻译后的文案、国家项为国家名），不再二次翻译


    const findDistributionStrategyLabel = value => {
      if (!value) return '/';
      const target = distributionStrategyOptions.value.find(item => item.value == value);
      return target ? target.label : value;
    }; // 打开终端审核弹框


    const onTerminalReviewShow = () => {
      terminalDialogVisible.value = true;
    }; // 确认终端审核


    const onTreminalReview = () => {
      terminalDialogVisible.value = false;
      loading.value = true;
      editCheckState({
        channelIds: props.detailInfo.id,
        state: 3
      }).then(res => {
        emit('update:modelValue', false);
        emit('update-list');
      }); // 销毁视频组件

      videoUrl.value = '';
      xgPlayerRef.value && xgPlayerRef.value.destroyVideo();
    }; // 重新审核


    const handleReCheck = () => {
      reCheck.value = true;
    }; // 销毁视频源的回调函数


    const handleVideoChange = e => {
      if (e === 'destory') {
        videoUrl.value = '';
      }
    }; // 组件销毁前


    onBeforeUnmount(() => {
      // 销毁视频组件
      videoUrl.value = '';
      xgPlayerRef.value && xgPlayerRef.value.destroyVideo();
    }); // 改变行的激活状态

    const onChangeState = (val, row) => {
      //val 激活：0  冻结:1
      console.log('row', row);
      console.log('channelData', channelData.value);
      console.log('bindingCategoryData', bindingCategoryData.value);

      if (val == 0) {
        messageBox(`${t('物理频道激活后会呈现在终端，确认激活吗')}?`).then(() => {
          row.state = val;
          editPhysicalState(row, val);
        });
      }

      if (val == 1) {
        if (row.programType === 0) {
          //h264
          //h264、传输协议与被点击物理频道相同的物理频道
          let h264PhysicalChannels = channelData.value.filter(item => item.transferProtocol === row.transferProtocol && item.programType === 0 && item.state === 0); //console.log('h264PhysicalChannels',h264PhysicalChannels)

          if (h264PhysicalChannels.length <= 1) {
            let bindingCategory = bindingCategoryData.value.filter(item => item.transferProtocol == row.transferProtocol); //console.log('正在绑定的分类',bindingCategory)

            if (bindingCategory.length > 0) {
              let text = bindingCategory.map(item => item.parentLabel + '-' + item.subBrandName + '-' + item.label).join(',');
              return ElMessage({
                type: 'error',
                message: t('传输协议正在被使用', {
                  bindingCategoryText: text
                })
              });
            }
          }
        }

        if (row.programType === 1) {
          //h265
          //传输协议与被点击物理频道相同的物理频道，不区分h264|h265
          let h265PhysicalChannels = channelData.value.filter(item => item.transferProtocol === row.transferProtocol && item.state === 0); //console.log('h265PhysicalChannels',h265PhysicalChannels)

          if (h265PhysicalChannels.length <= 1) {
            let bindingCategory = bindingCategoryData.value.filter(item => item.transferProtocol == row.transferProtocol); //console.log('正在绑定的分类',bindingCategory)

            if (bindingCategory.length > 0) {
              let text = bindingCategory.map(item => item.parentLabel + '-' + item.subBrandName + '-' + item.label).join(',');
              return ElMessage({
                type: 'error',
                message: t('传输协议正在被使用', {
                  bindingCategoryText: text
                })
              });
            }
          }
        }

        messageBox(`${t('确定冻结该物理频道吗')}?`).then(() => {
          row.state = val;
          editPhysicalState(row, val);
        });
      }

      emit('update-list');
    }; // 修改激活状态并请求列表


    const editPhysicalState = async (row, state) => {
      loading.value = true;
      const {
        code
      } = await editPhysicalStateApi(row.id, state);

      if (code == 0) {
        relationData.value = [];
        getChannelDetail(props.detailInfo.id);
      } else {
        console.error('修改激活状态失败'); //激活失败复原switch开关原有选项

        row.state = state === 1 ? 0 : 1;
      }
    }; // 从内容列表跳转到审核页面时，table中传输协议与内容列表传输协议相同的行高亮


    const tableRowClassName = ({
      row
    }) => {
      if (props.mode === 'detail') {
        if (row.transferProtocol == props.detailInfo.transferProtocol) {
          return 'using';
        }
      }
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_switch = _resolveComponent("el-switch");

      const _component_el_table = _resolveComponent("el-table");

      const _component_FormTable = _resolveComponent("FormTable");

      const _component_el_image = _resolveComponent("el-image");

      const _component_el_card = _resolveComponent("el-card");

      const _component_el_dialog = _resolveComponent("el-dialog");

      const _directive_loading = _resolveDirective("loading");

      return __props.modelValue ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t(__props.detailInfo.title)), 1), _createVNode(_component_el_button, {
        type: "primary",
        onClick: back
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
        _: 1
      })]), _createVNode(_component_el_card, null, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('频道')), 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_unref(XgPlayer), {
          url: videoUrl.value,
          onChange: handleVideoChange,
          ref_key: "xgPlayerRef",
          ref: xgPlayerRef
        }, null, 8, ["url"])]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_table, {
          data: channelData.value,
          style: {
            "width": "100%"
          },
          border: "",
          "header-cell-style": {
            background: '#eff5fb',
            color: '#80878f'
          },
          "max-height": "351",
          "tooltip-effect": "light",
          "row-class-name": tableRowClassName
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "programType",
            label: _ctx.$t('编码标准'),
            width: "110"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findLabel(sysDictList.value, scope.row.programType)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "transferProtocol",
            label: _ctx.$t('传输协议'),
            width: "150"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findLabel(transferProtocolObj.value, scope.row.transferProtocol)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "broadcastType",
            label: _ctx.$t('分辨率'),
            width: "110"
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findLabel(broadcastTypeObj.value, scope.row.broadcastType)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "state",
            label: _ctx.$t('激活状态'),
            width: "150"
          }, {
            default: _withCtx(scope => [__props.mode !== 'check' ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [_createTextVNode(_toDisplayString(_ctx.$t(findLabel(_unref(activeOrFrezz), scope.row.state))), 1)], 64)) : (_openBlock(), _createBlock(_component_el_switch, {
              key: 1,
              value: scope.row.state,
              "active-value": 0,
              "inactive-value": 1,
              onChange: $event => onChangeState($event, scope.row)
            }, null, 8, ["value", "onChange"]))]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "distributionStrategy",
            label: _ctx.$t('分发策略'),
            width: "140",
            "show-overflow-tooltip": true
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findDistributionStrategyLabel(scope.row.distributionStrategy)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "channelURL",
            label: _ctx.$t('频道URL'),
            "show-overflow-tooltip": true
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "httpHeaders",
            label: _ctx.$t('Http Headers'),
            "show-overflow-tooltip": true
          }, null, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "action",
            label: _ctx.$t('操作'),
            width: "100"
          }, {
            default: _withCtx(scope => [_createElementVNode("a", {
              href: "javascript:;",
              onClick: $event => play(scope.$index, scope.row),
              ref: setRef
            }, _toDisplayString(_ctx.$t('播放')), 9, _hoisted_9)]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["data"])])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('基础信息')), 1), _createVNode(_component_FormTable, {
          col: ['20%', '30%', '20%', '30%'],
          "form-list": actionForm.formList,
          "form-data": actionForm.formData
        }, null, 8, ["form-list", "form-data"])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('图片')), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_image, {
          class: "bg_img",
          "preview-src-list": srcList.value.bigIcon,
          src: picture.value[0] ? picture.value[0].fileURL : '',
          fit: _ctx.fit
        }, null, 8, ["preview-src-list", "src", "fit"]), _createElementVNode("div", _hoisted_16, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('频道图标')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('大尺寸')) + ": 200*200px", 1)])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_image, {
          class: "sm_img",
          "preview-src-list": srcList.value.smIcon,
          fit: _ctx.fit,
          src: picture.value[1] ? picture.value[1].fileURL : ''
        }, null, 8, ["preview-src-list", "fit", "src"]), _createElementVNode("div", _hoisted_18, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('频道图标')), 1), _createElementVNode("span", null, _toDisplayString(_ctx.$t('小尺寸')) + ": 60*60px", 1)])])])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('关联分类')), 1), _createVNode(_component_el_table, {
          data: relationData.value,
          style: {
            "width": "100%"
          },
          border: "",
          "header-cell-style": {
            background: '#eff5fb',
            color: '#80878f'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "index",
            label: _ctx.$t('序号')
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.$index + 1), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "category",
            label: _ctx.$t('一级分类'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.label ? scope.row.label : '/'), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "category",
            label: _ctx.$t('二级分类'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findCategoryLabel(scope.row, 2)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "category",
            label: _ctx.$t('三级分类'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findCategoryLabel(scope.row, 3)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "category4",
            label: _ctx.$t('四级分类'),
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx(scope => [_createTextVNode(_toDisplayString(findCategoryLabel(scope.row, 4)), 1)]),
            _: 1
          }, 8, ["label"]), _createVNode(_component_el_table_column, {
            prop: "notes",
            label: _ctx.$t('备注')
          }, {
            default: _withCtx(scope => [_hoisted_21]),
            _: 1
          }, 8, ["label"])]),
          _: 1
        }, 8, ["data"])]), __props.mode === 'check' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [(__props.detailInfo.state === 1 || __props.detailInfo.state === 2) && !reCheck.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "check-result",
          style: _normalizeStyle('background-color:' + (__props.detailInfo.state === 1 ? '#f5faf8' : ''))
        }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('审核结果')) + ":", 1), _createElementVNode("span", {
          class: "error-text",
          style: _normalizeStyle('color:' + (__props.detailInfo.state === 1 ? '#3aaf81' : ''))
        }, _toDisplayString(__props.detailInfo.state === 1 ? _ctx.$t('已通过审核') : _ctx.$t('未通过审核')), 5)]), __props.detailInfo.state === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('原因')) + ":", 1), _createElementVNode("span", null, _toDisplayString(__props.detailInfo.checkFailedReason ? __props.detailInfo.checkFailedReason : '/'), 1)])) : _createCommentVNode("", true)]), _unref(recheckBtnVisible) ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_el_button, {
          onClick: handleReCheck,
          class: "green-btn cms-op-btn cms-op-btn-main"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('重新审核')), 1)]),
          _: 1
        })])) : _createCommentVNode("", true)], 4)) : (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [__props.mode === 'check' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [_createVNode(_component_el_button, {
          type: "green",
          onClick: onTerminalReviewShow
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('终端审核')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: reviewSuccess
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('审核通过')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          onClick: reviewFail
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('审核不通过')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "yellow",
          onClick: onEditChannel
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('编辑频道')), 1)]),
          _: 1
        })], 64)) : (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: back
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
          _: 1
        }))])]))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [(__props.detailInfo.releaseState === 1 || __props.detailInfo.releaseState === 2) && !reCheck.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "check-result",
          style: _normalizeStyle('background-color:' + (__props.detailInfo.releaseState === 1 ? '#f5faf8' : ''))
        }, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.$t('上线状态')) + ":", 1), _createElementVNode("span", {
          class: "error-text",
          style: _normalizeStyle('color:' + (__props.detailInfo.releaseState === 1 ? '#3aaf81' : ''))
        }, _toDisplayString(__props.detailInfo.releaseState === 1 ? _ctx.$t('已上线') : _ctx.$t('已下线')), 5)]), __props.detailInfo.releaseState === 2 ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('下线原因')) + ":", 1), _createElementVNode("span", null, _toDisplayString(__props.detailInfo.offlineReason ? __props.detailInfo.offlineReason : '/'), 1)])) : _createCommentVNode("", true)])], 4)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: back
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('返回')), 1)]),
          _: 1
        })])])], 64))]),
        _: 1
      }), reviewSuccessObj.dialogVisible ? (_openBlock(), _createBlock(reviewSuccessModal, {
        key: 0,
        "dialog-object": reviewSuccessObj,
        onDialogClose: reviewSuccessCancel,
        onDialogSuccess: reviewSuccessSuc
      }, null, 8, ["dialog-object"])) : _createCommentVNode("", true), reviewFailObj.dialogVisible ? (_openBlock(), _createBlock(reviewFailModal, {
        key: 1,
        "dialog-object": reviewFailObj,
        onDialogClose: reviewFailCancel,
        onDialogSuccess: reviewFailSuc
      }, null, 8, ["dialog-object"])) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
        title: _ctx.$t('终端审核'),
        modelValue: terminalDialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => terminalDialogVisible.value = $event),
        width: "20%",
        "before-close": _ctx.handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_33, [_createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = $event => terminalDialogVisible.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('取消')), 1)]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onTreminalReview
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('确定')), 1)]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(_ctx.$t('确定将该频道设为终端审核')), 1)]),
        _: 1
      }, 8, ["title", "modelValue", "before-close"])])), [[_directive_loading, loading.value]]) : _createCommentVNode("", true);
    };
  }

});